// Voyager Energy Partners — Central content registry (Premium Dark Rebuild)

export const IMAGES = {
  heroBg: '/images/hero-bg.jpg',
  about: '/images/about.jpg',
  cardLng: '/images/card-lng.jpg',
  cardOil: '/images/card-oil.jpg',
  cardWetGas: '/images/card-wetgas.jpg',
  cardHydrogen: '/images/card-hydrogen.jpg',
  cardRenewables: '/images/card-renewables.jpg',
  cardTrading: '/images/card-distillates.jpg',
};

export const NAV_LINKS = [
  { label: 'Who We Are', href: '#about' },
  { label: 'What We Move', href: '#products' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Global Reach', href: '#reach' },
];

export const HERO = {
  eyebrow: 'Midstream Energy & Trading',
  headline: 'The molecules that\nmatter, moved with\nprecision.',
  sub:
    'Voyager Energy Partners is an independent midstream and trading company connecting global energy markets — from upstream production to end-market delivery.',
  cta_primary: 'Partner with Us',
  cta_secondary: 'What We Move',
};

export const ABOUT = {
  overline: 'Who We Are',
  headline: 'We operate where the global\nenergy supply chain is most critical.',
  body:
    'Founded by veterans of global energy trading and midstream operations, Voyager Energy Partners sits at the intersection of physical commodity logistics and market intelligence. We move LNG, crude oil, refined products, wet gas, hydrogen and renewable fuels — navigating complex infrastructure and volatile markets to consistently deliver value for our partners.',
  points: [
    'Independent origination across traditional and transitional energy molecules',
    'Proprietary trading desk with deep market intelligence across global basins',
    'End-to-end logistics from wellhead to buyer — blue-water shipping to pipeline',
  ],
};

export const PRODUCTS = [
  {
    name: 'LNG',
    tagline: 'Liquefied Natural Gas',
    desc:
      'We source, structure and physically move LNG across global terminals, connecting surplus supply with demand markets through spot, term and structured supply arrangements.',
    image: IMAGES.cardLng,
  },
  {
    name: 'Crude Oil',
    tagline: 'Crude & Refined Products',
    desc:
      'Originating from diversified upstream producers, our crude logistics capabilities span spot, term and structured supply — from wellhead to refinery gate.',
    image: IMAGES.cardOil,
  },
  {
    name: 'Wet Gas & NGLs',
    tagline: 'Natural Gas Liquids',
    desc:
      'Ethane, propane, butane and natural gasoline — high-value hydrocarbon streams serving petrochemical feedstock, export terminals and domestic distribution.',
    image: IMAGES.cardWetGas,
  },
  {
    name: 'Hydrogen',
    tagline: 'The Energy Carrier of Tomorrow',
    desc:
      'Building the physical pathways to connect green and blue hydrogen production with industrial demand centers — today\'s investment in tomorrow\'s energy infrastructure.',
    image: IMAGES.cardHydrogen,
  },
  {
    name: 'Renewables',
    tagline: 'Bio-fuels & Clean Energy',
    desc:
      'From bio-diesel and SAF to renewable natural gas, we trade and move drop-in sustainable fuels that accelerate our clients\' decarbonization commitments.',
    image: IMAGES.cardRenewables,
  },
  {
    name: 'Distillates',
    tagline: 'Gasoline, Diesel & Jet Fuels',
    desc:
      'We source and move refined distillate fuels — motor gasoline, diesel, jet fuel, heating oil and kerosene — across pipeline, barge and ocean-going vessel networks to meet industrial, commercial and transport demand.',
    image: IMAGES.cardTrading,
  },
];

export const CAPABILITIES = [
  {
    number: '01',
    title: 'Physical Origination',
    body:
      'Trusted relationships with upstream producers across North America, Europe and emerging markets enable consistent access to quality molecules at competitive terms.',
  },
  {
    number: '02',
    title: 'Midstream Logistics',
    body:
      'Our logistics platform coordinates pipeline access, terminal infrastructure and vessel nominations to deliver cargoes with precision and reliability, every time.',
  },
  {
    number: '03',
    title: 'Commodity Trading',
    body:
      'A seasoned trading desk executes across physical spot, forward curves and structured derivatives — providing clients with market liquidity and pricing transparency.',
  },
  {
    number: '04',
    title: 'Blue-water Shipping',
    body:
      'Deep maritime expertise enables Voyager to efficiently move cargoes across ocean basins, managing freight, demurrage, vessel scheduling and cargo integrity.',
  },
];

export const STATS = [
  { value: '6+', label: 'Commodities in active trade' },
  { value: '18', label: 'Global markets served' },
  { value: '24/7', label: 'Operational coverage' },
];

export const CONTACT_INFO = {
  email: 'info@voyagerenergy.com',
  location: 'JPMorgan Chase Tower\n600 Travis Street, Suite 6400\nHouston, Texas 77002',
  intro:
    'Whether you are securing offtake, structuring a supply arrangement or looking for a reliable midstream partner — our team is ready to move your molecules.',
};
